import React, { useState, useContext, useEffect } from "react";
import StandardButton from "../components/standardButton";
import StandardTextfield from "../components/standardTextfield";
import StandardSelect from "../components/standardSelect";
import FlexibleDataFetcher from "../components/flexibileDataFetcher";
import { UserContext } from '../components/context/UserContext';
import PaginatedTable from "../components/paginatedTable";
import { Pagination} from "@mui/material";

const selectablePayments = [
  {
    id: 0,
    name: 'Bonifico'
  },
  {
    id: 1,
    name: 'Fattura'
  }
]

export default function BillingDetails() {
  const [name, setName] = useState("");
  const [selectedPayment, setPayment] = useState("");
  const [company, setCompany] = useState({})
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [planInfo, setPlanInfo] = useState(null);
  const [planId, setPlanId] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  let companySelected = {}
  
  const user = useContext(UserContext);

  const userId = user.user.id;
  const companyId = user?.user?.companies?.[0]?.id ?? null;

  const [payments, setPayments] = useState([]);
  const [paymentPage, setPaymentPage] = useState(1);
  const [paymentTotalPages, setPaymentTotalPages] = useState(1);

  //console.log("user", user.user.companies[0].id)

  const handleCountriesList = (data) => {
    setSelectedCountry(data.data.map(country => ({
      id: parseInt(country.id), 
      name: country.name
    })));
    setLoading(false);
  };

  const handleCountriesListError = (err) => {
    setError(err)
    console.log(err)
  }

  const handleSubscriptionFetch = (data) => {
    //console.log("Dati ricevuti:", data.data[0].plan.id);
    setPlanInfo(data.data[0])
    setPlanId(data.data[0].plan.id)
    setLoading(false);
  };

  const handleSubscriptionError = (err) => {
    setError(err)
    //console.log(err)
  }

  const handlePlanFetch = (data) => {
    console.log("Dati ricevuti:", data);
    setPlanDetails(data)
  };

  const handlePlanError = (err) => {
    setError(err)
    //console.log(err)
  }


  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
  };

  const handleUserFetch = (data) => {
    // console.log(data)
    if(data && data.companies.length > 0) {
      setCompany(data.companies[0])
      companySelected = data.companies[0]
    }
  }

  // Handle data fetch error
  const handleUserFetchError = (err) => {
    setError(err.message || 'Failed to fetch data');
    setLoading(false);
  };
  
  const handleChangePayment = (event) => {
    setPayment(event.target.value);
  };

  const paymentColumns = [
    {
      field: 'planName',
      headerName: 'Plan Name',
      width: 200,
    },
    {
      field: 'planDuration',
      headerName: 'Duration (days)',
      width: 200,
    },
    {
      field: 'amount',
      headerName: 'Amount (€)',
      width: 200,
      renderCell: (params) => (
        <span>{(parseInt(params.value) / 100).toFixed(2)}</span>
      )
    },
    {
      field: 'created_at',
      headerName: 'Date',
      width: 200,
      renderCell: (params) => (
        <span>{new Date(params.value).toLocaleDateString("en-EN", {
          year: "numeric",
          month: "short",
          day: "numeric"
        })}</span>
      )
    },
  ];

  const fetchPayments = async (page = 1) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payments?page=${page}&per_page=15`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const result = await response.json();
      const formattedData = result.data.map(item => ({
        id: item.id,
        planName: item.metadata?.planName || "N/A",
        planDuration: item.metadata?.planDuration || "N/A",
        amount: item.amount,
        created_at: item.created_at
      }));

      setPayments(formattedData);
      setPaymentPage(result.current_page);
      setPaymentTotalPages(result.last_page);
    } catch (err) {
      console.error("Error fetching payments:", err);
    }
  };

  useEffect(() => {
    fetchPayments(paymentPage);
  }, [paymentPage]);


  return (
    <React.Fragment>
      <div className="bg-black h-full min-h-[100vh] flex p-5">
        <div className="flex flex-col gap-10 h-full bg-[rgba(255,255,255,0.1)] p-5 w-full rounded-2xl">
          <h1 className="text-6xl font-medium">Billing Details</h1> 
          <div className="flex gap-5 flex-wrap justify-between">
            <div className="flex flex-col gap-2">
              <span className="text-lg font-semibold">Subscription details</span>
              <span>Your account is on: <span className="text-[rgb(var(--global-color-primary))]">{planInfo?.plan?.name}</span></span>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex gap-2">
                <span className="font-semibold">Plan name:</span>
                <span className="text-[rgb(var(--global-color-primary))]">{planDetails?.name}</span>
              </div>
              <div className="flex gap-2">
                <span className="font-semibold">Plan Expiration Date:</span>
                <span className="text-[rgb(var(--global-color-primary))]">
                  {planInfo?.ends_at 
                    ? new Date(planInfo.ends_at).toLocaleDateString("en-EN", {
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                      }) 
                    : "N/A"
                  }
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex gap-2">
                <span className="font-semibold">Plan Duration:</span>
                <span className="text-[rgb(var(--global-color-primary))]">{planInfo?.plan.duration}</span>
              </div>
              <div className="flex gap-2">
                <span className="font-semibold">Plan Price:</span>
                <span className="text-[rgb(var(--global-color-primary))]">{(planDetails?.price / 100).toFixed(2)} €</span>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-lg font-semibold">Your next billing date is:</span>
              <span className="text-[rgb(var(--global-color-primary))]">
                {planInfo?.ends_at 
                  ? new Date(planInfo.ends_at).toLocaleDateString("en-EN", {
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                    }) 
                  : "N/A"
                }
              </span>
            </div>
          </div>

          <div className="mt-10">
            <h2 className="text-3xl font-semibold mb-4">Your Payments</h2>
            <PaginatedTable
              header={paymentColumns}
              items={payments}
              hideFooterPagination={true}
            />
            {paymentTotalPages > 1 && (
              <div className="flex justify-center mt-6">
                <Pagination
                  count={paymentTotalPages}
                  page={paymentPage}
                  onChange={(event, value) => setPaymentPage(value)}
                  color="primary"
                />
              </div>
            )}
          </div>

          
        </div>
      </div>
      <FlexibleDataFetcher
        endpoint="subscriptions"
        params={{ company_id: companyId, user_id: userId }}
        onSuccess={handleSubscriptionFetch}
        onError={handleSubscriptionError}
      />

      {planId && (
        <FlexibleDataFetcher
          endpoint={`plans/${planId}`}
          onSuccess={handlePlanFetch}
          onError={handlePlanError}
        />
      )}


      <FlexibleDataFetcher
        endpoint="user"
        onSuccess={handleUserFetch}
        onError={handleUserFetchError}
      />
      <FlexibleDataFetcher
        endpoint={"values/countries"}
        onSuccess={handleCountriesList}
        onError={handleCountriesListError}
      />
    </React.Fragment>
  );
}